import { api } from 'shared/api';
import { Card } from 'entities/card/model/types';
import { ApiResponse } from 'shared/model/types';

const replaceApi = api.injectEndpoints({
  endpoints: (build) => ({
    replaceVirtual: build.mutation<
      ApiResponse<Card>,
      {
        accountId: number;
        cardId: number;
      }
    >({
      query: ({ accountId, cardId }) => ({
        url: `private/river/${accountId}/card/virtual/${cardId}/replace`,
        method: 'POST',
      }),
    }),
    replacePlastic: build.mutation<
      ApiResponse<Card>,
      {
        accountId: number;
        cardId: number;
        deliveryType: string;
      }
    >({
      query: ({ accountId, cardId, deliveryType }) => ({
        url: `private/river/${accountId}/card/physical/${cardId}/replace`,
        method: 'POST',
        params: { cardDeliveryMethodId: deliveryType },
      }),
    }),
  }),
});

export const { useReplaceVirtualMutation, useReplacePlasticMutation } = replaceApi;

export default replaceApi;
